import { Component, Fragment, h, Prop } from '@stencil/core';
import { StaticCartArticle } from './interfaces';

@Component({
  tag: 'rtr-cart-article-static',
  styleUrl: 'style-details.sass',
  shadow: false,
})
export class RTRCartArticleStatic {
  @Prop() article: StaticCartArticle;
  @Prop() allowTotalPrice: boolean;

  get priceAmount() {
    if (this.article.itemAmount > 1) {
      return this.article.itemAmount + 'x\xa0';
    }
  }

  get renderIncludedArticles() {
    if (this.article.includedArticles?.length > 0) {
      return this.article.includedArticles.map(item => {
        return (
          <Fragment>
            <rentware-spacer size='S' />

            <div class='RTRADArticle RTRADMinorArticle'>
              <div class='RTRADDescriptionText RTRADSubItem'>{item.title}</div>

              <div class='RTRADPrice'>x{item.amount}</div>
            </div>
          </Fragment>
        );
      });
    }
  }

  get renderConnectedArticles() {
    if (this.article.connectedArticles?.length > 0) {
      return this.article.connectedArticles.map(item => {
        return (
          <Fragment>
            <rentware-spacer size='S' />

            <div class='RTRADArticle RTRADMinorArticle'>
              <div class='RTRADDescriptionText RTRADSubItem'>{item.title}</div>

              <div class='RTRADPrice RTRADPriceInline'>
                {this.priceAmount}
                <rentware-item-price price={item.price} />
              </div>
            </div>
          </Fragment>
        );
      });
    }
  }

  get renderDeposit() {
    if (this.article.connectedDeposit) {
      return (
        <Fragment>
          <rentware-spacer size='S' />

          <div class='RTRADArticle RTRADMinorArticle'>
            <div class='RTRADDescriptionText RTRADSubItem'>{this.article.connectedDeposit.title}</div>
          </div>
        </Fragment>
      );
    }
  }

  get renderMileage() {
    if (!this.article.connectedMileage) {
      return null
    }

    const showTotalPrice = this.allowTotalPrice && this.article.connectedMileage.totalPrice.gross !== this.article.connectedMileage.price.gross

    return (
      <Fragment>
        <rentware-spacer size='S' />

        <div class='RTRADArticle RTRADMinorArticle'>
          <div class='RTRADInfo'>
            <div class='RTRADDescription'>
              <span
                class='RTRADDescriptionTitle RTRADDescriptionText'>{this.article.connectedMileage.mileageTitle}</span>
              <span class='RTRADDescriptionText'>{this.article.connectedMileage.mileageText}</span>
            </div>
          </div>
            <div class='RTRADPrice RTRADPriceInline'>
              {this.priceAmount}
              <rentware-item-price price={this.article.connectedMileage.price} />
              {showTotalPrice &&
                <Fragment>
                  <br/>
                  <rtr-cart-item-total-price price={this.article.connectedMileage.totalPrice} />
                </Fragment>
              }
            </div>
          </div>
      </Fragment>
    );
  }

  render() {
    const showTotalPrice = this.allowTotalPrice && this.article.totalPrice.gross !== this.article.price.gross

    return (
      <div class='RTRADContainer'>
        <div class='RTRADArticle'>
          <div class='RTRADInfo'>
            <div class='RTRADImage'>
              <rentware-image src={this.article.image} alt={this.article.articleTitle} vw={40} vh={40}
                              forceAspectRatio={true} />
            </div>
            <div class='RTRADDescription'>
              <span class='RTRADDescriptionTitle RTRADDescriptionText'>{this.article.articleTitle}</span>
              <span class='RTRADDescriptionText'>{this.article.articleText}</span>
            </div>
          </div>
          <div class='RTRADPrice'>
            <span>
              {this.priceAmount}
              <rentware-item-price price={this.article.price} />
              {showTotalPrice &&
                <Fragment>
                  <br/>
                  <rtr-cart-item-total-price price={this.article.totalPrice} />
                </Fragment>
              }
            </span>
          </div>
        </div>
        {this.renderConnectedArticles}
        {this.renderMileage}
        {this.renderDeposit}
      </div>
    );
  }
}
